import React from "react";

import SignUpForm from "../components/SignUp";

const SignUp = () => {
  return <SignUpForm />;
};

export default SignUp;
